/**
 * お気に入りボタン（サイズ展開なし商品用）
 *
 * 表示はテーマ側で持ち、登録・解除は Prime Review の Ajax API
 * （window.PrimeReviewFavorite）に投げる。処理の流れは size-rows.js と同じ。
 *
 * 純正ボタンを使わない理由は snippets/favorite-button.liquid のコメントを参照。
 */
(function() {
  'use strict';

  if (window.__favoriteButtonInit) return;
  window.__favoriteButtonInit = true;

  function init(scope) {
    var wraps = scope.querySelectorAll('[data-favorite-button-wrap]');

    for (var i = 0; i < wraps.length; i++) {
      setupWrap(wraps[i]);
    }
  }

  function setupWrap(wrap) {
    if (wrap.dataset.favoriteButtonBound === 'true') return;
    wrap.dataset.favoriteButtonBound = 'true';

    var btn = wrap.querySelector('[data-favorite-button]');
    if (!btn) return;

    btn.addEventListener('click', function(evt) {
      evt.preventDefault();
      toggleFavorite(wrap, btn);
    });
  }

  function getFavoriteApi() {
    // 解除も使うので removeFavorite まで確認する。
    // 欠けたまま呼ぶと同期的に例外が飛び、ボタンが disabled のまま固まる
    var api = window.PrimeReviewFavorite;
    if (!api) return null;
    if (typeof api.submitFavorite !== 'function') return null;
    if (typeof api.removeFavorite !== 'function') return null;
    return api;
  }

  function toggleFavorite(wrap, btn) {
    // Prime Review 未導入・未読み込みでもテーマ側がエラーにならないようにする
    var api = getFavoriteApi();
    if (!api) {
      console.warn('[favorite-button] PrimeReviewFavorite is not available');
      return;
    }

    if (btn.disabled) return;
    btn.disabled = true;
    showMessage(wrap, '');

    var isFaved = btn.dataset.faved === 'true';
    var method = isFaved ? api.removeFavorite : api.submitFavorite;

    Promise.resolve(
      method.call(api, wrap.dataset.productHandle, btn.dataset.variantId, wrap.dataset.customerId)
    )
      .then(function() {
        var next = !isFaved;
        btn.dataset.faved = String(next);
        btn.classList.toggle('is-active', next);
        btn.setAttribute('aria-pressed', String(next));

        var label = wrap.querySelector('[data-favorite-button-text]');
        if (label) {
          label.textContent = next ? wrap.dataset.addedText : wrap.dataset.addText;
        }
      })
      .catch(function(err) {
        console.warn('[favorite-button] favorite failed', err);
        showMessage(wrap, wrap.dataset.errorText);
      })
      .then(function() {
        btn.disabled = false;
      });
  }

  function showMessage(wrap, text) {
    var msg = wrap.querySelector('[data-favorite-button-msg]');
    if (!msg) return;
    msg.textContent = text;
  }

  /* ============================================================
     起動
     ============================================================ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); });
  } else {
    init(document);
  }

  // テーマエディタでのセクション再描画に対応する
  document.addEventListener('shopify:section:load', function(evt) {
    init(evt.target);
  });
})();
